import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=0272c74e"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=0272c74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports